module.exports = __webpack_public_path__ + "static/b97490e8.dsers.png";